import Dropdown from "../../../common/dropdown/Dropdown";
import PropTypes from "prop-types";

const EditOrderOption = ({option, selectedOption, onChange}) => {
    const {title, values} = option;
    const {value, id} = selectedOption || {};
    const items = values.map(el => ({key: el, text: el}));
    const handleOptionChange = (newOption) => {
        onChange(newOption.key, id);
    }
    return (
        <Dropdown
            label={title}
            items={items}
            selectedText={value}
            onChange={handleOptionChange}
        />
    );
}

EditOrderOption.propTypes = {
    option: PropTypes.object.isRequired,
    selectedOption: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default EditOrderOption;
